const featureTextCarousel = (): void => {
  const selectors = {
    featureTextCarousel: '[data-feature-text-carousel]',
    slideContainer: '[data-slides]',
    slide: '[data-slide]',
    currentSlide: 'data-current-slide',
    prevButton: '[data-slide-prev]',
    nextButton: '[data-slide-next]',
  };

  const featureTextCarouselSections = document.querySelectorAll(
    selectors.featureTextCarousel
  );

  const setActiveSlide = (slideContainer: HTMLElement, slide: any): void => {
    const activeSlide = slideContainer.querySelector(
      '[data-slide="' + slide + '"]'
    );
    const slideHeight = activeSlide.scrollHeight + 'px';
    slideContainer.style.setProperty('height', slideHeight);
    slideContainer.setAttribute(selectors.currentSlide, slide);
  };

  featureTextCarouselSections.forEach((section) => {
    let activeSlide = 1;
    const slideContainer = section.querySelector<HTMLElement>(
      selectors.slideContainer
    );
    const prevButton = section.querySelector(selectors.prevButton);
    const nextButton = section.querySelector(selectors.nextButton);
    const slideCount = section.querySelectorAll(selectors.slide).length;
    const currentSlide = slideContainer.getAttribute(selectors.currentSlide);

    setActiveSlide(slideContainer, currentSlide);

    window.addEventListener('resize', () => {
      const currentSlide = slideContainer.getAttribute(selectors.currentSlide);
      setActiveSlide(slideContainer, currentSlide);
    });

    if (prevButton) {
      prevButton.addEventListener('click', () => {
        if (activeSlide == 1) {
          activeSlide = slideCount;
        } else {
          activeSlide = activeSlide - 1;
        }
        setActiveSlide(slideContainer, activeSlide);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', () => {
        if (activeSlide < slideCount) {
          activeSlide++;
        } else {
          activeSlide = 1;
        }
        setActiveSlide(slideContainer, activeSlide);
      });
    }
  });
};

export default featureTextCarousel;
